import { render, staticRenderFns } from "./mainItem.vue?vue&type=template&id=3fe68020&scoped=true&"
import script from "./mainItem.vue?vue&type=script&lang=js&"
export * from "./mainItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe68020",
  null
  
)

export default component.exports